import { useForm } from "react-hook-form";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";
import StyledButton from "../../components/styled/StyledButton";
import StyledInput from "../../components/styled/StyledInput";
import { zodResolver } from "@hookform/resolvers/zod";
import { useResetPassword } from "../../api/auth.api";
import ArrowLeft from "../../assets/icons/arrow-left.svg?react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ResetPasswordFormData,
  ResetPasswordSchema,
} from "../../types/forms/auth/resetPasswordFormData.form";
import Paths from "../../constants/paths";

const ResetPasswordPage = () => {
  const translateMessage = useTranslateMessage();
  const navigate = useNavigate();
  const { token } = useParams();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<ResetPasswordFormData>({
    resolver: zodResolver(ResetPasswordSchema),
    defaultValues: { password: "", passwordConfirmation: "", token },
  });

  const { mutateAsync: resetPassword } = useResetPassword();

  const onSubmit = async (data: ResetPasswordFormData) => {
    resetPassword(data)
      .then(() => {
        navigate(Paths.auth.resetPasswordSuccess);
      })
      .catch(() => {
        setError("token", { message: "Le lien est invalide ou expiré" });
      });
  };

  return (
    <div className="bg-brand600 flex min-h-screen w-screen items-center justify-center">
      <div className="mx-4 flex flex-col items-center gap-4 rounded-2xl bg-white px-6 py-6 md:min-h-[500px] md:min-w-[600px] md:gap-16 md:px-16 md:py-12">
        <img src="/images/pelican-logo.png" className="h-32 w-32" />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-center text-3xl font-medium text-black">Nouveau mot de passe</h1>
          <p className="text-center text-sm text-gray-600">Entrez un nouveau mot de passe</p>
        </div>

        <div className="flex w-full flex-col gap-4">
          <StyledInput
            title="Nouveau mot de passe"
            control={control}
            name="password"
            type="password"
          />
          <StyledInput
            title="Confirmation du mot de passe"
            control={control}
            name="passwordConfirmation"
            type="password"
          />
        </div>

        {errors.token ? (
          <p className="text-xs text-red-500">{translateMessage(errors.token.message)}</p>
        ) : null}

        <div className="flex w-full flex-col gap-2">
          <StyledButton onClick={handleSubmit(onSubmit)}>
            Réinitialiser le mot de passe
          </StyledButton>
          <StyledButton mode="secondary" onClick={() => navigate("/login")}>
            <div className="gap flex items-center justify-center gap-2">
              <ArrowLeft />
              Retour à la connexion
            </div>
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
